<template>
  <div class="w-full">
    <div v-if="success" >
      <p>
        <slot />
      </p>
    </div>
    <div v-else >
      <div class="w-full" >
        <form class="grid lg:grid-cols-5 gap-4 px-4" >

          <div v-if="hasError" class="lg:col-span-5" >
            <p class="text-error font-bold">Errors in your submission were found. Correct the indicated fields and try again:</p>
            <ul>
            <li
              v-for="error in errors"
              :key="error"
              class="text-error font-bold text-sm"
            >{{ error }}</li>
            </ul>
          </div>

          <div class="grid md:grid-cols-2 gap-4 lg:col-span-3" >
            <div class="input-wrapper pl-2">
              <label for="first-name" class="sr-only">First Name *</label>
              <input
                v-model="formData.fname"
                id="first-name"
                type="text"
                class="text-input"
                :class="{ 'border-error': hasError && formData.fname == '' }"
                placeholder="First Name"
                required
              >
            </div>

            <div class="input-wrapper pl-2">
              <label for="last-name" class="sr-only">Last Name *</label>
              <input
                v-model="formData.lname"
                id="last-name"
                type="text"
                class="text-input"
                :class="{ 'border-error': hasError && formData.lname == '' }"
                placeholder="Last Name"
                required
              >
            </div>

            <div class="input-wrapper pl-2">
              <label for="email-address" class="sr-only">Email Address *</label>
              <input
                v-model="formData.email"
                id="email-address"
                type="email"
                class="text-input"
                :class="{ 'border-error': hasError && formData.email == '' }"
                placeholder="Email Address"
                required
              >
            </div>

            <div class="input-wrapper pl-2">
              <label for="phone-number" class="sr-only">Phone Number</label>
              <input
                v-model="formData.phone"
                id="phone-number"
                type="tel"
                class="text-input"
                placeholder="Phone Number"
                required
              >
            </div>

            <div class="input-wrapper md:col-span-2">
              <label for="interest" class="sr-only">Area of Interest</label>
              <select id="interest" class="form-select" v-model="formData.interest">
                <option value="" disabled >Area of Interest</option>
                <option>Cape San Blas</option>
                <option>Indian Pass</option>
                <option>Port St. Joe</option>
                <option>St. Joe Beach</option>
                <option>Windmark Beach</option>
                <option>Mexico Beach</option>
                <option>St. George Island</option>
                <option>Apalachicola</option>
                <option>Wewahitchka</option>
                <option>Carrabelle</option>
              </select>
            </div>
          </div>



          <div class="grid gap-4 lg:col-span-2">

            <label for="message" class="sr-only">Message</label>
            <textarea
              type="text"
              id="message"
              v-model="formData.message"
              class="textarea-input p-4 overflow-hidden leading-normal min-h-full"
              placeholder="Is there anything else you'd like us to know?"
              required
            />
          </div>

          <div class="lg:col-span-5 flex flex-col xl:flex-row items-center dark:text-white pt-6" >
            <button
              @click.prevent="submitForm"
              type="submit"
              :disabled="processing"
              class="form-button py-2 px-4 md:px-6 border-2 border-accent bg-primary-dark text-accent hover:bg-accent hover:text-primary-dark"
            >
              Register & Contiue Browsing
            </button>
            <div
              v-if="!processing"
              class="text-sm p-4 leading-none"
              :class="{ 'text-error font-bold': this.hasError }" >
              * = required.</div>
            <div
              v-if="processing"
              class="text-sm p-4 leading-none "
              >Sending&nbsp;inquiry.</div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SignupForm',
  props: {
    nonce: {
      type: String,
      default: '',
    },
    userIp: {
      type: String,
      default: '',
    },
    userAgent: {
      type: String,
      default: '',
    },
    referrer: {
      type: String,
      default: '',
    },
    form: {
      type: String,
      default: 'Signup Form'
    },
    to: {
      type: String,
      default: ''
    },
    source: {
      type: Object,
      default: () => {}
    },
  },

  data () {
    return {
      processing: false,
      errors: {},
      errorCode: null,
      success: false,
      hasError: false,
      formData: {
        fname: '',
        lname: '',
        phone: '',
        email: '',
        interest: '',
        message: '',
        form: this.form,
        source: this.source,
        to: this.to,
      },
      submitted: false,
    }
  },

  computed: {
    validate() {
      return this.formData.fname != '' &&
        this.formData.lname != '' &&
        this.formData.phone != '' &&
        this.formData.email != '' &&
        this.formData.message != ''
    },
  },

  mounted () {
    this.formData.post_id = this.postId
    this.formData.user_ip = this.userIp
    this.formData.user_agent = this.userAgent
    this.formData.referrer = this.referrer

    var paused = window.localStorage.getItem('paused')
    if (paused === 'false'){
      localStorage['paused'] = 'true'
    }
  },

  methods: {
    submitForm () {
      this.processing = true

      fetch('/wp-json/kma/v1/submit-signup-form', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': this.nonce
        },
        body: JSON.stringify(this.formData)
      })
        .then(r => r.json())
        .then((res) => {
          if(res.success == true){
            this.$emit('submit')
            this.success      = true
            dataLayer.push({
              'event': 'form_submitted',
              'form_name': 'Signup Form',
              'form_type': 'popup',
            })
          } else {
            this.success      = false
            this.hasError     = true
            this.errors       = res.data
          }

          this.processing   = false
        })
    },

  }
}
</script>
